import { useInfiniteQuery } from '@tanstack/react-query';

import { getNextPageParam } from '@pkg/hooks/deprecated';

import { type Competition } from '@app/client';
import { callLeaderboardCompetitionWishlist } from '@app/client/resources/competitions';

const DEFAULT_LIMIT = 100;
export const COUNT_CACHE = 'leaderboard-count-cache';
export function useLeaderboardCount(competition?: Competition, disabled = false) {
    const enabled = !disabled && competition && competition?.multigame && Boolean(competition?.slug);
    const { data: leaderboardData } = useInfiniteQuery({
        queryKey: [COUNT_CACHE, competition?.slug],
        queryFn: ({ pageParam = 0 }) => {
            return callLeaderboardCompetitionWishlist({
                slug: competition?.slug || '',
                query: {
                    page: pageParam || 0,
                    limit: DEFAULT_LIMIT,
                },
            });
        },
        enabled,
        initialPageParam: 0,
        getNextPageParam,
        retry: false,
        notifyOnChangeProps: 'all',
    });
    return leaderboardData?.pages?.[0]?.paging?.total || 0;
}
